import { Typography } from "@mui/material";
import { useAuthStore } from "@store/auth.store";
import { useEffect, useState } from "react";

type Props = {
  finishedDuration?: number;
  keepCounting?: boolean;
};

export const MessageRequestDuration = (props: Props) => {
  const { finishedDuration, keepCounting } = props;
  const [duration, setDuration] = useState(finishedDuration ?? 0);
  const preferences = useAuthStore((state) => state.preferences);

  useEffect(() => {
    if (preferences.showChatPromptRequestDuration === false) return;

    const stepMs = 100;

    const interval = setInterval(() => {
      setDuration((previous) => previous + stepMs);
    }, stepMs);

    if (finishedDuration && finishedDuration > 0) {
      setDuration(finishedDuration);
      clearInterval(interval);
    }

    if (!finishedDuration && !keepCounting) {
      clearInterval(interval);
    }

    return () => {
      clearInterval(interval);
    };
  }, [
    finishedDuration,
    keepCounting,
    preferences.showChatPromptRequestDuration,
  ]);

  if (preferences.showChatPromptRequestDuration === false) return null;

  if (!finishedDuration && !keepCounting) return null;

  if (finishedDuration) {
    return (
      <Typography variant="body2">
        Took {duration.toLocaleString()} ms
      </Typography>
    );
  }

  return (
    <Typography variant="body2">{duration.toLocaleString()} ms</Typography>
  );
};
